<template>
  <v-dialog ref="dialog" v-model="exibir" :return-value.sync="hora" persistent width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field slot="activator" v-model="hora" prepend-inner-icon="access_time" readonly v-bind="attrs" v-on="on" :label="label"></v-text-field>
    </template>
    <v-time-picker v-if="exibir" v-model="hora" format="24hr" full-width>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="exibir = false">Cancelar</v-btn>
      <v-btn text color="primary" @click="$refs.dialog.save(hora)">OK</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  name: "as-time-picker",

  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      exibir: false,
    };
  },

  methods: {
    horaAgora() {
      let data = new Date();
      return data.getHours() + ":" + data.getMinutes();
    },
  },

  computed: {
    hora: {
      get() {
        return this.value;
      },
      set(hora) {
        this.$emit("input", hora);
      },
    },

    setAgora() {
      this.hora = this.horaAgora();
    },
  },
};
</script>

<style scoped></style>
